export const USER_ID = process.env.REACT_APP_USER_ID;
export const API_BASE = process.env.REACT_APP_API_BASE;

export const SUGGESTIONS = [
  "Is it true that OpenAI released GPT-5?",
  "What's happening with Tesla lately?",
  "Did Apple acquire a new company recently?",
  "Is the India-Pakistan ceasefire still holding?",
];
